import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import { Body1 } from '../../atomic/text/Text';
import { colors } from '../../../colorVars';

export const NavClock = () => {
  const [currentTime, setCurrentTime] = useState(null);
  const [currentTime24hr, setCurrentTime24hr] = useState(null);
  const [military, setMilitary] = useState(false);
  const switchTimeFormat = () => {
    setMilitary((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const now = DateTime.now().setZone('America/New_York');
      const twelve = now.toLocaleString({
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      });
      const twentyFour = now.toLocaleString({
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
      });
      setCurrentTime(twelve);
      setCurrentTime24hr(twentyFour);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <div
      onDoubleClick={switchTimeFormat}
      style={{
        display: 'flex',
        width: '230px',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {currentTime && (
        <Body1 color={colors.green} fontWeight={700}>
          {military ? currentTime : currentTime24hr}
        </Body1>
      )}
    </div>
  );
};

NavClock.propTypes = {
  military: PropTypes.bool,
};
